import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RetreatRegistrationForm.css';

const RetreatRegistrationForm = () => {
  const navigate = useNavigate();

  return (
    <section className="registration-section">
      <form
        action="https://formspree.io/f/xrbllyyd"
        method="POST"
        className="registration-form"
      >
        <h2 className="registration-header">Maldives Yoga Registration Form</h2>
        <p className="registration-subtext">
          Please do fill out the firm, to help tailor your experience.
        </p>

        <div className="form-grid">
          <div className="form-group">
            <label htmlFor="fullName">Full Name:</label>
            <input id="fullName" type="text" name="Full Name" placeholder="Your name" required />
          </div>

          <div className="form-group">
            <label htmlFor="age">Age:</label>
            <input id="age" type="number" name="Age" placeholder="Your age" required />
          </div>

          <div className="form-group">
            <label htmlFor="nationality">Nationality:</label>
            <input id="nationality" type="text" name="Nationality" placeholder="e.g. Australian" required />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input id="email" type="email" name="Email" placeholder="Your email" required />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number (with country code):</label>
            <input id="phone" type="tel" name="Phone Number" placeholder="+61 412 345 678" required />
          </div>

          <div className="form-group">
            <label htmlFor="emergency">Emergency Contact:</label>
            <input id="emergency" type="text" name="Emergency Contact" placeholder="Name & number" required />
          </div>

          <div className="form-group full-width">
            <label htmlFor="room">Single or double room (if double, are you coming with someone?):</label>
            <textarea
              id="room"
              name="Room Preference"
              placeholder="Single or Double room? If double, who are you coming with?"
              rows="2"
              required
            />
          </div>

          <div className="form-group full-width">
            <label htmlFor="diet">Dietary Restrictions:</label>
            <textarea
              id="diet"
              name="Dietary Restrictions"
              placeholder="e.g. vegan, gluten-free, nut allergy"
              rows="2"
            />
          </div>

          <div className="form-group full-width">
            <label htmlFor="yogaExperience">How long have you been practising yoga:</label>
            <input
              id="yogaExperience"
              type="text"
              name="Yoga Experience"
              placeholder="e.g. 2 years practicing vinyasa yoga"
            />
          </div>

          <div className="form-group full-width">
            <label htmlFor="goals">What are you hoping to get out of this retreat:</label>
            <textarea
              id="goals"
              name="Retreat Goals"
              placeholder="Share your intentions or personal goals..."
              rows="3"
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="submit-button">
            Submit Registration
          </button>
          <button
            type="button"
            className="back-button"
            onClick={() => navigate('/maldives-retreat')}
          >
            ← Back to Retreat Page
          </button>
        </div>
      </form>
    </section>
  );
};

export default RetreatRegistrationForm;
